import { mapToBreakpoints } from './mapToBreakpoints.js';

/**
 * Get a CSS display declaration, optionally for particular breakpoint(s)
 * @param {string|object} values CSS display value, optionally for a given breakpoint (e.g. 'none' or {m: 'none'})
 * @returns {string} CSS display declaration
 */
const getDisplayStyle = values => () => {
  return mapToBreakpoints(values, value => {
    return `display: ${value};`;
  });
};

export { getDisplayStyle };
//# sourceMappingURL=getDisplayStyle.js.map
